import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import ApplicationLayout from 'v3/layouts/Application';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import Space from 'v3/components/Space';

import { Section } from '../shared/Section';
import { Data } from '../shared/Data';

import { useVehicleBodies } from '../shared/context';

import { handleCreation } from './controller';
import { OwnerData } from '../shared/Owner';
import { usePermission } from 'hooks';

export function VehicleBodiesRegister() {
  const navigate = useNavigate();
  const vehicleBody = useVehicleBodies();

  const [loading, setLoading] = useState(false);

  usePermission('CADASTRAR_CARROCERIA', {
    redirect: true,
  });

  return (
    <ApplicationLayout
      title="Cadastrar carroceria"
      RightComponent={
        <Space x={'0.5rem'}>
          <Button
            variant="secondary"
            onClick={() => navigate('/carrocerias')}
          >
            <Text color="dark" weight={500}>
              Voltar
            </Text>
          </Button>
          <Button
            variant="primary"
            loading={loading}
            onClick={() =>
              handleCreation(
                vehicleBody.data,
                vehicleBody.setErrors,
                vehicleBody.showSnackbar,
                setLoading,
                navigate
              )
            }
          >
            <Text color="white" weight={500}>
              Salvar
            </Text>
          </Button>
        </Space>
      }
    >
      <Row>
        <Col xs={12} md={6}>
          <Section Title="Dados da carroceria">
            <Data />
          </Section>
        </Col>
        <Col xs={12} md={6}>
          <Section Title="Proprietário">
            <OwnerData />
          </Section>
        </Col>
      </Row>
    </ApplicationLayout>
  );
}
